import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Row, Radio, Button, Checkbox, Switch, Space, Input } from "antd";
import { Option } from "antd/es/mentions";

// import productApi from "../../../apis/Product.api";
import AWS from "aws-sdk";
import moment from "moment";

import colorSyntax from "@toast-ui/editor-plugin-color-syntax";
import { Editor } from "@toast-ui/react-editor";

import insightApi from "../../../apis/Insight.api";
import {
  setLoading,
  setSearchText,
} from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import InsightListComponent from "./InsightListComponent";

const s3 = new AWS.S3();
const InsightComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const isLoading = useSelector((state) => state.common.loading);
  const editorRef = useRef(null);

  const [editorShow, setEditorShow] = useState(true);

  const toolbarItems = [
    ["heading", "bold", "italic", "strike"],
    ["link", "image"],
    // ['table', 'link'],
    // ['hr'],
    ["table"],
    ["ul", "ol", "task"],
    // ['code'],
    ["scrollSync"],
  ];

  const [editorHeight, setEditorHeight] = useState("50vh");

  const [searchValue, setSearchValue] = useState("");

  const buttonCategory = [
    {
      name: "리뷰",
      id: "review",
    },
    {
      name: "배송",
      id: "delivery",
    },
    {
      name: "컴플레인",
      id: "complain",
    },
    {
      name: "결제",
      id: "purchase",
    },
    {
      name: "전화상담",
      id: "call",
    },
  ];

  const [categoryFilter, setCategoryFilter] = useState("all");

  const [editorToolbar, setEditorToolbar] = useState({
    positive: true,
    category: "review",
    category_name: "리뷰",
    important: false,
  });
  const [selectInsightList, setSelectInsightList] = useState([]);
  const [totalInsightIdList, setTotalInsightIdList] = useState([]);
  const [insightList, setInsightList] = useState([]);
  const [editClick, setEditClick] = useState(false);

  useEffect(() => {
    readInsightAll();
  }, []);

  /**
   * 인사이트 리스트 전부 가져오기
   * @returns {Promise<void>}
   */
  const readInsightAll = async () => {
    setIsLoading(true);
    let param = {
      offset: 0,
      // pageSize: 10,
    };

    const res = await insightApi.readAllInsight(param);
    if (res.code === 200) {
      setInsightList(res.result.insightList);
      setTotalInsightIdList(res.result.insightIdList);
    }
    setIsLoading(false);
  };

  /**
   * 새 글 작성하기
   */
  const cancelBtnClick = () => {
    if (window.confirm("작성중인 글이 있습니다. 취소하시겠습니까?")) {
      setEditorToolbar({
        positive: true,
        category: "review",
        category_name: "리뷰",
        important: false,
      });
      editorRef.current?.getInstance().setHTML("");
      setEditClick(false);
    }
  };

  /**
   * 인사이트 게시글 작성하기
   * @returns {Promise<void>}
   */
  const createInsight = async () => {
    const content = editorRef.current?.getInstance().getHTML();
    // 새로 생성
    if (!editClick) {
      setIsLoading(true);
      let param = {
        positive: editorToolbar.positive, // boolean
        category: editorToolbar.category, // string
        category_name: editorToolbar.category_name, // string
        important: editorToolbar.important, // boolean
        content: content, // html 형식 longText
        created_by: user?.id,
      };
      const res = await insightApi.createInsight(param);
      if (res.code === 200) {
        setIsLoading(false);
        readInsightAll();
        setEditorToolbar({
          positive: true,
          category: "review",
          category_name: "리뷰",
          important: false,
        });
        editorRef.current?.getInstance().setHTML("");
      }
    }
  };

  /**
   * 인사이트 글 수정하기
   * @param item
   * @returns {Promise<void>}
   */
  const updateInsight = async () => {
    const content = editorRef.current?.getInstance().getHTML();
    // 수정하기
    if (editClick) {
      setIsLoading(true);
      let param = {
        id: editClick,
        positive: editorToolbar.positive, // boolean
        category: editorToolbar.category, // string
        category_name: editorToolbar.category_name, // string
        important: editorToolbar.important, // boolean
        content: content, // html 형식 longText
        updated_by: user.id, // 수정자
      };
      const res = await insightApi.editInsight(param);
      if (res.code === 200) {
        alert("해당 게시글 수정이 완료되었습니다.");
        setIsLoading(false);
        readInsightAll();
        setEditorToolbar({
          positive: true,
          category: "review",
          category_name: "리뷰",
          important: false,
        });
        editorRef.current?.getInstance().setHTML("");
      } else {
        alert(res.msg);
      }
    }
  };

  /**
   * 인사이트 글 삭제하기
   * @returns {Promise<void>}
   */
  const handleDeleteClick = async () => {
    if (
      window.confirm(
        `총 ${selectInsightList?.length}개의 게시글을 삭제처리하시겠습니까?`,
      )
    ) {
      try {
        setIsLoading(true);
        const param = {
          insightIdList: selectInsightList,
          updated_by: user.id,
        };
        const res = await insightApi.deleteInsight(param);
        if (res.code === 200) {
          alert("선택된 게시글들의 삭제 처리가 완료되었습니다.");
          setSelectInsightList([]);
          readInsightAll();
        } else {
          throw res.msg;
        }
        setIsLoading(false);
      } catch (e) {
        alert(e);
      }
    }
  };

  const addImageBlobHook = async (blob, callback) => {
    // let fileType = blob.type.split("/")[1]
    let s3Path = `image/insight/${user.id}-${moment(new Date()).format(
      "YYMMDDmmss",
    )}`;
    let param = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: s3Path,
      Body: blob,
    };
    let res = await s3.putObject(param).promise();

    if (res.$response.httpResponse.statusCode === 200) {
      return callback(`${process.env.REACT_APP_S3_HOST}/${s3Path}`);
    } else {
      alert(
        "해당 파일을 업로드하는데 실패했습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
      );
    }
  };

  /**
   * 전체 선택/해제
   */
  const handelTotalSelectClick = (e) => {
    if (e.target.checked) {
      setSelectInsightList(totalInsightIdList);
    } else {
      setSelectInsightList([]);
    }
  };

  /**
   * 해당 게시글 선택/해제
   */
  const handleSelectInsightClick = (e) => {
    let currIdList = selectInsightList;
    const { id, checked } = e.target;
    if (checked) {
      currIdList = [...currIdList, id];
    } else {
      currIdList = currIdList.filter((listId) => listId !== id);
    }
    setSelectInsightList(currIdList);
  };

  /**
   * 콘텐츠 글 클릭
   * @param item
   */
  const contentEachClick = (item) => {
    editorRef.current?.getInstance().setHTML(item.content);
    setEditClick(item.id);
    setEditorToolbar({
      positive: item.positive,
      category: item.category,
      category_name: item.category_name,
      important: item.important,
    });
  };

  return (
    <>
      <ContentHeaderComponent title="인사이트" />
      <div className="order-component-wrap">
        <div
          className={`order-component-body`}
          style={{
            width: "100%",
          }}
        >
          <Row
            className="order-component-box"
            style={{
              padding: "1.5rem",
              gap: 10,
              rowGap: 10,
            }}
          >
            {/* 헤더 - 토글버튼/검색창 */}
            <Space
              className={`insight-toolbar-each`}
              style={{ justifyContent: "space-between" }}
            >
              <Row align={"middle"} style={{ gap: 8 }}>
                <Switch
                  onChange={(e) => setEditorShow(e)}
                  checked={editorShow}
                />
                {!editorShow ? <span>작성하기</span> : <span>글만보기</span>}
              </Row>
            </Space>

            {/* 필터 */}
            <Row
              style={{
                gap: 10,
                rowGap: 10,
                flexDirection: "column",
                paddingTop: 5,
              }}
            >
              <div
                className={`insight-toolbar-each-filter`}
                style={{
                  width: "100%",
                  overflowX: "scroll",
                  display: "flex",
                  gap: 8,
                }}
              >
                {[
                  {
                    id: "all",
                    name: "전체",
                  },
                  ...buttonCategory,
                ].map((item, idx) => (
                  <Button
                    style={
                      categoryFilter === item.id
                        ? {
                            borderRadius: 8,
                            backgroundColor: "#117ffa",
                            color: "white",
                          }
                        : {
                            borderRadius: 8,
                          }
                    }
                    key={`category-${idx}`}
                    value={item.id}
                    onClick={() => {
                      setCategoryFilter(item.id);
                    }}
                  >
                    {item.name}
                  </Button>
                ))}
              </div>
              <Input.Search
                name="insight-search"
                allowClear={true}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder={`인사이트 검색`}
                style={{
                  width: "35%",
                  minWidth: "200px",
                }}
              />
            </Row>

            <div className={`insight-wrap`}>
              <img
                src={`/assets/images/top-btn.png`}
                alt={"탑 버튼"}
                style={{
                  position: "fixed",
                  bottom: "3rem",
                  right: "3rem",
                  cursor: "pointer",
                  width: "3rem",
                  height: "3rem",
                  zIndex: 1,
                }}
                onClick={() => {
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
              />
              <div
                className={`insight-editor`}
                id={`insight-editor`}
                style={
                  editorShow
                    ? {}
                    : {
                        display: "none",
                      }
                }
              >
                <div className={`insight-toolbar`}>
                  <Space className={`insight-toolbar-each`}>
                    <Switch
                      checked={editorToolbar.positive}
                      onChange={(e) =>
                        setEditorToolbar({
                          ...editorToolbar,
                          positive: e,
                        })
                      }
                    />
                    {editorToolbar.positive ? (
                      <span
                        style={{
                          color: "#117ffa",
                        }}
                      >
                        긍정
                      </span>
                    ) : (
                      <span
                        style={{
                          color: "#fe2b4b",
                        }}
                      >
                        부정
                      </span>
                    )}
                  </Space>
                  <Radio.Group
                    className={`insight-toolbar-each`}
                    value={editorToolbar.category}
                    // name={editorToolbar.category_name}
                    onChange={(e) => {
                      setEditorToolbar({
                        ...editorToolbar,
                        category: e.target.value,
                        category_name: e.target.id,
                      });
                    }}
                  >
                    {buttonCategory.map((item, idx) => (
                      <Radio.Button
                        className={`category`}
                        key={`버튼 타입 ${idx}`}
                        value={item.id}
                        id={item.name}
                      >
                        {item.name}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                  <Space className={`insight-toolbar-each`}>
                    <div className={`insight-checkbox`}>
                      <Checkbox
                        checked={editorToolbar.important}
                        onChange={(e) => {
                          setEditorToolbar({
                            ...editorToolbar,
                            important: e.target.checked,
                          });
                        }}
                      >
                        <span>중요</span>
                      </Checkbox>
                      <img
                        className={`yellow-star`}
                        alt={"중요 아이콘"}
                        src={`/assets/images/yellow-star.png`}
                      />
                    </div>
                  </Space>
                </div>
                <Editor
                  ref={editorRef}
                  initialEditType={"wysiwyg"} // wysiwyg & markdown
                  initialValue={""} // 글 수정 시 사용
                  // initialValue={contentTitle.content || ""} // 글 수정 시 사용
                  previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
                  hideModeSwitch={true}
                  theme={""} // '' & 'dark'
                  usageStatistics={false}
                  toolbarItems={toolbarItems}
                  useCommandShortcut={true}
                  plugins={[colorSyntax]}
                  language="ko-KR"
                  hooks={{
                    addImageBlobHook: addImageBlobHook,
                  }}
                  height={editorHeight}
                />
                <Row
                  justify={`center`}
                  align={`middle`}
                  style={{
                    padding: "0.5em 0",
                  }}
                >
                  <img
                    src={`/assets/images/notice-${
                      editorHeight !== "50vh" ? "fold" : "expand"
                    }.png`}
                    alt={`에디터 접기펼치기 아이콘`}
                    style={{
                      width: "2.3em",
                      height: "auto",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (editorHeight !== "50vh") {
                        setEditorHeight("50vh");
                      } else {
                        setEditorHeight("65vh");
                      }
                    }}
                  />
                </Row>
                <div className={`order-component-each insight-button-group`}>
                  <Button
                    className="product-register-button cancel"
                    onClick={cancelBtnClick}
                    loading={isLoading}
                  >
                    {editClick ? "새 글 작성하기" : "취소"}
                  </Button>
                  <Button
                    className="product-register-button save"
                    onClick={editClick ? updateInsight : createInsight}
                    loading={isLoading}
                  >
                    {editClick ? "수정완료" : "작성완료"}
                  </Button>
                </div>
              </div>
              <div className={`insight-div`}>
                <Row
                  justify={`space-between`}
                  align={`middle`}
                  className={`insight-checkbox-group`}
                >
                  <Checkbox
                    checked={
                      selectInsightList?.length === totalInsightIdList?.length
                    }
                    onChange={handelTotalSelectClick}
                  >
                    <span>전체선택</span>
                  </Checkbox>
                  <Button
                    disabled={selectInsightList?.length === 0}
                    onClick={handleDeleteClick}
                    loading={isLoading}
                  >
                    선택 삭제
                  </Button>
                </Row>

                {insightList?.filter((item) => {
                  if (categoryFilter !== "all") {
                    return item.category === categoryFilter;
                  } else {
                    return item.category;
                  }
                })?.length ? (
                  <>
                    {insightList
                      ?.filter((item) => {
                        if (categoryFilter !== "all") {
                          return item.category === categoryFilter;
                        } else {
                          return item.category;
                        }
                      })
                      ?.map((item, idx) => {
                        if (item.content?.includes(searchValue)) {
                          return (
                            <div
                              className={`insight-each ${
                                item.important ? "important" : ""
                              }`}
                              key={`insight content ${idx}`}
                              onClick={() => contentEachClick(item)}
                            >
                              <InsightListComponent
                                item={item}
                                selectInsightList={selectInsightList}
                                handleSelectInsightClick={
                                  handleSelectInsightClick
                                }
                              />
                            </div>
                          );
                        }
                      })}
                  </>
                ) : (
                  <div
                    className={`insight-each`}
                    style={{
                      padding: "5em 0",
                    }}
                  >
                    <Row
                      justify={`center`}
                      align={`middle`}
                      style={{ rowGap: "0.5em" }}
                    >
                      <div
                        className={`insight-each-header`}
                        style={{
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "1em",
                          color: "#868e96",
                        }}
                      >
                        <img
                          src={`/assets/images/warning.png`}
                          alt={`warning-icon`}
                          style={{
                            width: "3em",
                            height: "auto",
                          }}
                        />
                        작성글이 없습니다.
                      </div>
                    </Row>
                  </div>
                )}
              </div>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};

export default InsightComponent;
